import type { HandlingItemRow, TariffRateRow, WarehouseFields } from './fixtures';

/** V1 warehouse subtotals, recalculated from the current draft on every render. */
export function warehouseWithTotals(
  warehouse: WarehouseFields,
  charges: TariffRateRow[],
  handling: HandlingItemRow[],
): WarehouseFields {
  const dray = charges
    .filter((c) => c.scope === 'transloadquote' && c.rateType === 'IN RATE')
    .reduce((total, c) => total + (Number(c.rate) || 0), Number(warehouse.drayRate) || 0);
  const handled = handling
    .filter((h) => h.rateType === 'IN RATE' && h.unitType === warehouse.drayHandlingUnitType)
    .reduce((total, h) => total + (Number(h.rate) || 0), Number(warehouse.drayHandlingCharge) || 0);
  // Dollars and cents, as the Direct tab computes its own Total With Charges
  // (`(drayRate + inRateCharges).toFixed(2)`). Five places showed 215.00000
  // against Direct's 215.00 for the same money. The column is decimal(13,5) on
  // both tables, so this drops trailing zeros, not value.
  return { ...warehouse, drayWithCharges: dray.toFixed(2), handlingWithCharges: handled.toFixed(2) };
}
